import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL
const externalBaseUrl = process.env.VUE_APP_API_PUBLIC_EXTERNAL

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    address_ids: queryParam?.address_ids || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/samator/stock',
    params: params,
  })

  return response?.data
}

export const print = async (type, shipmentReference) => {
  const response = await apiClientV2({
    baseURL: externalBaseUrl,
    method: 'GET',
    url: `/samator/printTP/${type}/${shipmentReference}`
  })
  
  return response?.data
}

export const validateQuantity = async (fleet_task_id) => {
  const response = await apiClientV2({
    baseURL: externalBaseUrl,
    method: 'POST',
    url: `/samator/fleet-order/release-for-picking-bulk`,
    data: {fleet_task_id}
  })
  
  return response?.data
}


export const quantityConversion = async (data) => {
  const response = await apiClientV2({
    baseURL: externalBaseUrl,
    method: 'POST',
    url: `/samator/order/qty-conversion`,
    data,
  })
  
  return {
    code: response.status,
    ...response.data,
  }
}
